import { Props } from './types';
import style from './styles.module.css';

const ColorPicker = ({ name, value, onChange }: Props) => (
  <input onChange={onChange} className={style.colorPicker} type="color" name={name} value={value} />
);

export default ColorPicker;
